import TripsForm from '../components/TripsForm.vue';
import Vue from 'vue';
const TripsFormHandler = (item, action, callback) => {
  const vm = new Vue({
    ...TripsForm,
    propsData: { item, action, callback },
  });
  vm.$mount();
  vm.$bvModal.show('trips-form-modal');
};
export default TripsFormHandler;
